var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107,
    height: 108,
    viewBox: "0 0 107 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5378 5.52247L49.369 54.8566C46.1621 48.2179 34.3265 32.4931 45.4862 27.1023C49.7333 25.0507 54.8872 26.8472 56.9387 31.0942L64.8135 47.396C61.6699 40.8884 51.4583 27.0402 62.0362 21.9304C66.0666 19.9835 72.7204 23.9606 75.0821 27.9667C75.2021 28.1702 80.1532 39.7188 80.2585 39.9367C77.1184 33.4362 69.6578 22.369 80.2585 17.2482C84.5055 15.1967 88.4912 19.1895 90.5427 23.4366L105.233 60.7467C110.168 79.4366 97.1514 94.5919 88.9337 98.5616L77.4812 103.437C71.7937 106.374 59.8405 104.534 56.9387 102.562L7.15627 72.9003C-2.2251 66.5211 7.41943 52.3381 16.8008 58.7173L39.7121 74.2981L10.0934 12.983C5.28544 3.02992 20.7299 -4.43063 25.5378 5.52247Z",
    fill: "#FDA57F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9108 8.23829L46.7421 57.5724C43.5352 50.9337 31.6996 35.2089 42.8593 29.8181C47.1063 27.7665 52.2602 29.563 54.3118 33.8101L62.1865 50.1119C59.0429 43.6043 48.8313 29.756 59.4093 24.6462C63.4396 22.6993 70.0934 26.6764 72.4552 30.6825C72.5751 30.8861 77.5263 42.4346 77.6315 42.6525C74.4914 36.1521 67.0309 25.0848 77.6315 19.9641C81.8785 17.9125 85.8642 21.9053 87.9158 26.1524L102.606 63.4625C107.541 82.1524 94.5245 97.3078 86.3068 101.277L74.8543 106.152C69.1668 109.09 57.2135 107.25 54.3118 105.277L4.52932 75.6161C-4.85205 69.2369 4.79247 55.0539 14.1738 61.4331L37.0851 77.014L7.4664 15.6988C2.65848 5.74574 18.1029 -1.71481 22.9108 8.23829Z",
    fill: "url(#paint0_linear_319_35531)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_35531",
    x1: 36.292,
    y1: 11.2783,
    x2: 95.292,
    y2: 107.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCEB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9C4AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/Cursor.e6698e3b052a8410dc11.svg";
export { ForwardRef as ReactComponent };